export const FETCH_PAYMENT_PLAN_REQUEST = 'FETCH_PAYMENT_PLAN_REQUEST';
export const FETCH_PAYMENT_PLAN_ERROR = 'FETCH_PAYMENT_PLAN_ERROR';
export const FETCH_PAYMENT_PLAN_SUCCESS = 'FETCH_PAYMENT_PLAN_SUCCESS';
